
import { Input } from "@/components/ui/input";
import { ImageDropzone } from "../ImageDropzone";
import type { Block } from "../types";

interface ImageBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
}

export const ImageBlock = ({ block, onUpdate }: ImageBlockProps) => {
  return (
    <div className="space-y-2">
      <ImageDropzone
        value={block.content}
        onChange={(base64) => onUpdate({ content: base64 })}
      />
      <Input
        value={block.url || ""}
        onChange={(e) => onUpdate({ url: e.target.value })}
        placeholder="Enter link URL (optional)"
      />
    </div>
  );
};
